
import Popup from 'vux/src/components/popup/index.vue'

export default {
name: "pur-requisition-list",
components:{Popup},
data(){
return{
typeJson: {},
tabIndex:1,
wrapperHeight:0,
allLoaded:false,
config:{
title:'采购申请',
url:'api/purRequisition/page',
property: "createdDate",
inputCondition:{
placeholder:'申请单号/物料编号/名称',
searchCondition:'key',
rules:[{field:"code-matName-matCode", option: "LIKE_ANYWHERE"}]
},
selectConfig:[
{
text: '申请类型',
type: 'selector',
list: [],
rules:[{field:"type",option:"IN"}]
},






{
text: '是否删除',
type: 'selector',
code: "0",
list:[{name:'全部',code:null},{name:'是',code:'1'},{name:'否',code:'0'}],
rules:[{field:"deleted",option: "EQ"}],
},
{
type: 'more',
condition: "purchaseApply",
list:[{name:'全部',code:null},{name:'是',code:'1'},{name:'否',code:'0'}],
rules:[{field:"deleted",option: "EQ"}],
}
]
},
list:[],
popupShow:false,
showDetail:{},
typeShowValueList:[],
purTypeList:[]
}
},
methods:{
getTabIndex(e){
this.tabIndex = e;
},
getList(e,met,bol){
this.$nextTick(()=>{
if(bol){
this.list = this.list.concat(e);
}else{
this.list = e;
}
if(met === 'top'){
this.$refs.loadmore.onTopLoaded();
}
if(met === 'bottom'){
this.$refs.loadmore.onBottomLoaded();
}
})
},
init: function() {

this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top - 10;
},
loadTop(){
this.$refs.header.getlist(true);
},
loadBottom(){
this.$refs.header.getMore();
},
viewDetail(item){
if(item.requestId){
this.goFlow(item.requestId)
}else{
this.popupShow = true;
this.showDetail = item;
console.log(item)
}
},
getTypeValueList(){
this.$get('api/pur-requisition-type/all').then((res) => {
if(res){
this.typeShowValueList = [{name:'全部',code:null}];
res.forEach((item) => {
let obj = {
name:item.value,
code:item.code
};
this.typeShowValueList.push(obj);
this.typeJson[item.code] = item.value
});
this.config.selectConfig[0].list = this.typeShowValueList;
}
});













},
goFlow(requestId){
this.$router.push('/workflow/'+requestId+'?component=PurRequisitionDrawerComponent')
}
},
mounted(){
this.init();
this.getTypeValueList();
this.$refs.header.getlist();
}
}



// WEBPACK FOOTER //
// ./src/page/purchase-requisition/pur-requisition-list.vue